import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, Stack, IconButton } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { TopicsMultiAutocomplete } from './TopicAutocomplete';

/**
 * Multi-select topics plus ordered list with up/down controls (exam prep, semester templates, etc.).
 */
export default function TopicSequencePicker({
  topicOptions = [],
  value = [],
  onChange,
  disabled = false,
  loading = false,
  subjectSelected = true,
  autocompleteLabel = 'Topics (order = study sequence)',
  helperTextWhenNoSubject = 'Select a subject first',
  helperTextDefault = 'Use arrows below to change 1st, 2nd, … order',
  showQuestionCount = false,
  orderSectionTitle = 'Topic order',
}) {
  const moveTopic = (index, delta) => {
    const next = [...value];
    const j = index + delta;
    if (j < 0 || j >= next.length) return;
    const t = next[index];
    next[index] = next[j];
    next[j] = t;
    onChange(next);
  };

  return (
    <>
      <TopicsMultiAutocomplete
        label={autocompleteLabel}
        options={topicOptions}
        value={value}
        onChange={onChange}
        disabled={!subjectSelected || disabled}
        loading={loading}
        showQuestionCount={showQuestionCount}
        helperText={!subjectSelected ? helperTextWhenNoSubject : helperTextDefault}
      />
      {value.length > 0 && (
        <Box>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
            {orderSectionTitle}
          </Typography>
          <List dense disablePadding>
            {value.map((t, idx) => (
              <ListItem
                key={t.id}
                secondaryAction={
                  <Stack direction="row">
                    <IconButton
                      size="small"
                      aria-label="Move up"
                      onClick={() => moveTopic(idx, -1)}
                      disabled={disabled || idx === 0}
                    >
                      <ArrowUpwardIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      aria-label="Move down"
                      onClick={() => moveTopic(idx, 1)}
                      disabled={disabled || idx === value.length - 1}
                    >
                      <ArrowDownwardIcon fontSize="small" />
                    </IconButton>
                  </Stack>
                }
              >
                <ListItemText primary={`${idx + 1}. ${t.topic || t.name || t.id}`} />
              </ListItem>
            ))}
          </List>
        </Box>
      )}
    </>
  );
}
